import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider as ReduxProvider } from 'react-redux';

import { store, persistor } from './redux/store';
import history from './history';
import UserProvider from './contexts/UserContext';
import VehiclesProvider from './contexts/VehiclesContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AuctionsPage from './pages/AuctionsPage';
import DealerReceptor from './pages/DealerReceptorPage';
import DirectPurchase from './pages/DirectPurchasePage';
import LoginPage from './pages/LoginPage';
import Profile from './components/Profile';
import Adjudications from './pages/AdjudicationsPage';
import SoldVWR from './pages/SoldVWRPage';
import LegalNote from './pages/LegalNotePage';
import PrivacyPolicy from './pages/PrivacyPolicyPage';
import CookiesPolicy from './pages/CookiesPolicyPage';
import Licenses from './pages/LicensesPage';
import Faqs from './pages/FaqsPage';
import Contact from './pages/ContactPage';
import ResetEmailPassword from './pages/ResetEmailPasswordPage';
import Batches from './pages/BatchesPage';
import BatchDetails from './pages/BatchDetailsPage';
import CreateTicket from './pages/CreateTicketPage';
import SearchTicket from './pages/SearchTicketPage';
import ClosedBatchDetails from './pages/ClosedBatchDetails';
import RentingRedRac from 'pages/RentingRedRacPage';
import VehicleStatus from 'pages/VehicleStatusPage';

import Huerto from './components/huerto/scoring/scoringTable';
import MetricasHuerto from './components/huerto/metricas/index';
import TextoLanding from './components/huerto/scoring/textoLanding/textoLanding';
import AuthPage from './pages/AuthPage';

import Globals from './Globals';
import './css/global.css';
import IsUserLogged from 'components/IsUserLogged';
import CacheBuster from './CacheBuster';

function App() {
    return (
        <ReduxProvider store={store}>
            <CacheBuster />
            <UserProvider>
                <LanguageProvider>
                    <VehiclesProvider>
                        <Layout>
                            <PersistGate loading={null} persistor={persistor}>
                                <Switch>
                                    <Route
                                        exact
                                        path={Globals.APPLICATION_PATH.LOGIN}
                                        component={LoginPage} //error from route expecting func received component fixed in react router dom 4.4 or 5.0+ , deprecated lifecycles too
                                    />
                                    <Route
                                        exact
                                        path={Globals.APPLICATION_PATH.REGISTER}
                                        component={LoginPage} //error from route expecting func received component fixed in react router dom 4.4 or 5.0+ , deprecated lifecycles too
                                    />
                                    <Route
                                        exact
                                        path={
                                            Globals.APPLICATION_PATH.AUTH +
                                            '/:value'
                                        }
                                        component={AuthPage}
                                    />
                                    <Route
                                        exact
                                        path="/ResetEmailPassword/"
                                        component={ResetEmailPassword}
                                    />
                                    <Route
                                        exact
                                        path={
                                            Globals.APPLICATION_PATH.LEGAL_NOTE
                                        }
                                        component={LegalNote}
                                    />
                                    <Route
                                        exact
                                        path={
                                            Globals.APPLICATION_PATH
                                                .PRIVACY_POLICY
                                        }
                                        component={PrivacyPolicy}
                                    />
                                    <Route
                                        exact
                                        path={
                                            Globals.APPLICATION_PATH
                                                .COOKIES_POLICY
                                        }
                                        component={CookiesPolicy}
                                    />
                                    <Route
                                        exact
                                        path={Globals.APPLICATION_PATH.LICENCE}
                                        component={Licenses}
                                    />
                                    <Route
                                        exact
                                        path={Globals.APPLICATION_PATH.FAQS}
                                        component={Faqs}
                                    />
                                    <Route
                                        exact
                                        path={Globals.APPLICATION_PATH.CONTACT}
                                        component={Contact}
                                        history={history}
                                    />
                                    <IsUserLogged>
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH.PROFILE
                                            }
                                            component={Profile}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .PROFILE + '/:value'
                                            }
                                            component={Profile}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .REGISTER
                                            }
                                            component={LoginPage} //error from route expecting func received component fixed in react router dom 4.4 or 5.0+ , deprecated lifecycles too
                                        />
                                        <Route
                                            exact
                                            path={Globals.APPLICATION_PATH.HOME}
                                            component={HomePage}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH.AUCTION
                                            }
                                            component={AuctionsPage}
                                            history={history}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .AUCTION + '/:value'
                                            }
                                            component={AuctionsPage}
                                            history={history}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .DIRECT_PURCHASE
                                            }
                                            component={DirectPurchase}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .RECEIVINGDEALER
                                            }
                                            component={DealerReceptor}
                                        />
                                        <Route
                                            exact
                                            path="/adjudications"
                                            component={Adjudications}
                                        />
                                        <Route
                                            exact
                                            path="/soldvwr"
                                            component={SoldVWR}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH.BATCHES
                                            }
                                            component={Batches}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .BATCHES + '/:value'
                                            }
                                            component={BatchDetails}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .CLOSED_BATCH + '/:value'
                                            }
                                            component={ClosedBatchDetails}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .CREATE_TICKET
                                            }
                                            component={CreateTicket}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .SEARCH_TICKET
                                            }
                                            component={SearchTicket}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .RENTING_RED_RAC
                                            }
                                            component={RentingRedRac}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .SEARCH_VEHICLE_STATUS
                                            }
                                            component={VehicleStatus}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH.HUERTO
                                            }
                                            component={Huerto}
                                            history={history}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .METRICASHUERTO
                                            }
                                            component={MetricasHuerto}
                                            history={history}
                                        />
                                        <Route
                                            exact
                                            path={
                                                Globals.APPLICATION_PATH
                                                    .TEXTOLANDINGHUERTO
                                            }
                                            component={TextoLanding}
                                            history={history}
                                        />
                                    </IsUserLogged>
                                </Switch>
                            </PersistGate>
                        </Layout>
                    </VehiclesProvider>
                </LanguageProvider>
            </UserProvider>
        </ReduxProvider>
    );
}
export default App;
